module.exports = __webpack_public_path__ + "static/media/lidcore-detection-2.82c1f3de.jpg";